var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nrk"},[_vm._m(0),_c('div',{staticClass:"achie"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.CaseOther.content)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Servic"},[_c('p',[_vm._v("主要业绩")])])
}]

export { render, staticRenderFns }